export default {
	actionIcon: 'StarIcon',
	highlightColor: 'warning',
	data: [
    // DASHBOARDS
		{index: 0, label: '仪表盘', url: '/dashboard', labelIcon: 'HomeIcon', highlightAction: true},

    // SETTING
		{index: 1, label: '设置 - 基础', url: '/setting/base', labelIcon: 'SettingsIcon', highlightAction: true},
    {index: 2, label: '设置 - 风控', url: '/setting/notification', labelIcon: 'SettingsIcon', highlightAction: false},
		{index: 3, label: '设置 - NG', url: '/setting/ng', labelIcon: 'SettingsIcon', highlightAction: false},
		{index: 4, label: '设置 - 活动', url: '/setting/activity', labelIcon: 'SettingsIcon', highlightAction: false},
    {index: 5, label: '设置 - 线路', url: '/setting/speed', labelIcon: 'SettingsIcon', highlightAction: false},
    {index: 6, label: '设置 - 轮播', url: '/setting/slide', labelIcon: 'SettingsIcon', highlightAction: false},

    // ADMIN
    {index: 7, label: '管理员 - 列表', url: '/admin/list', labelIcon: 'UsersIcon', highlightAction: true},

    // USER
		{index: 8, label: '会员 - 列表', url: '/user/list', labelIcon: 'UserIcon', highlightAction: true},
    {index: 9, label: '会员 - 银行卡', url: '/user/bank', labelIcon: 'UserIcon', highlightAction: false},
    {index: 10, label: '会员 - 用户组', url: '/user/group', labelIcon: 'UserIcon', highlightAction: false},

    // MONEY
		{index: 11, label: '资金 - 提款银行', url: '/money/send', labelIcon: 'CreditCardIcon', highlightAction: true},
		{index: 12, label: '资金 - 收款银行', url: '/money/receive', labelIcon: 'CreditCardIcon', highlightAction: false},
    {index: 13, label: '资金 - 第三方支付', url: '/money/pay', labelIcon: 'CreditCardIcon', highlightAction: false},

    // LOTTERY
    {index: 14, label: '彩票 - 彩种管理', url: '/lottery/list', labelIcon: 'LifeBuoyIcon', highlightAction: true},
    {index: 15, label: '彩票 - 玩法管理', url: '/lottery/played', labelIcon: 'LifeBuoyIcon', highlightAction: false},
    {index: 16, label: '彩票 - 时间管理', url: '/lottery/time', labelIcon: 'LifeBuoyIcon', highlightAction: false},
    {index: 17, label: '彩票 - 时间管理LHC', url: '/lottery/timeLhc', labelIcon: 'LifeBuoyIcon', highlightAction: false},
    {index: 18, label: '彩票 - 开奖数据', url: '/lottery/data', labelIcon: 'LifeBuoyIcon', highlightAction: false},

    // RECORD
    {index: 19, label: '彩票注单', url: '/record/lottery', labelIcon: 'ArchiveIcon', highlightAction: true},
    {index: 20, label: '游戏注单', url: '/record/game', labelIcon: 'ArchiveIcon', highlightAction: false},
    {index: 21, label: '提现记录', url: '/record/cash', labelIcon: 'DollarSignIcon', highlightAction: false},
    {index: 22, label: '充值记录', url: '/record/recharge', labelIcon: 'DollarSignIcon', highlightAction: false},
    {index: 23, label: '会员日志', url: '/record/cash', labelIcon: 'FileIcon', highlightAction: false},
    {index: 24, label: '活动日志', url: '/record/activity', labelIcon: 'FileIcon', highlightAction: false},
    {index: 25, label: '管理员日志', url: '/record/admin', labelIcon: 'FileIcon', highlightAction: false},

    // REPORT
    {index: 26, label: '会员报表', url: '/report/user', labelIcon: 'PieChartIcon', highlightAction: true},
    {index: 27, label: '彩票报表', url: '/report/lottery', labelIcon: 'PieChartIcon', highlightAction: false},
    {index: 28, label: '游戏报表', url: '/report/game', labelIcon: 'PieChartIcon', highlightAction: false},
    {index: 29, label: '团队报表', url: '/report/team', labelIcon: 'PieChartIcon', highlightAction: false},

    // OTHER
    {index: 30, label: '文章列表', url: '/article/list', labelIcon: 'BookIcon', highlightAction: false},
    {index: 31, label: '数据清理', url: '/other/clean', labelIcon: 'Trash2Icon', highlightAction: false},
    {index: 32, label: '程序更新', url: '/other/update', labelIcon: 'RefreshCwIcon', highlightAction: true}
	]
}
